/* Collection grid: sort + filter chips update in place (no reload, no scroll jump). Falls back to normal navigation on any problem. */
(function () {
  if (window.SixFtCollectionSort) return;
  window.SixFtCollectionSort = { ready: true };

  var busy = 0;
  function sections() {
    return Array.prototype.slice.call(document.querySelectorAll('[id^="shopify-section-"][id$="__grid"], [id^="shopify-section-"][id$="__hero"]'));
  }

  function swap(url, push) {
    var token = ++busy;
    var grid = document.querySelector('[id^="shopify-section-"][id$="__grid"]');
    if (grid) grid.style.opacity = '0.55';
    return fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (token !== busy) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ok = false;
        sections().forEach(function (cur) {
          var next = doc.getElementById(cur.id);
          if (!next) return;
          if (cur.innerHTML !== next.innerHTML) {
            var x = window.scrollX, y = window.scrollY;
            cur.innerHTML = next.innerHTML;
            window.scrollTo(x, y);
          }
          if (/__grid$/.test(cur.id)) ok = true;
        });
        if (!ok) throw new Error('no grid');
        if (doc.title) document.title = doc.title;
        if (push) history.pushState({ cgAjax: 1 }, '', url);
        if (grid) grid.style.opacity = '';
        document.dispatchEvent(new CustomEvent('sixft:grid-updated'));
      })
      .catch(function () { window.location.href = url; });
  }

  function clean(href) {
    var u = new URL(href, window.location.href);
    u.hash = '';
    return u.toString();
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('.cg-chip, [id^="shopify-section-"][id$="__grid"] .pagination a, [id^="shopify-section-"][id$="__grid"] [class*="pagination"] a');
    if (!a || !a.href || a.target === '_blank') return;
    var u = new URL(a.href, window.location.href);
    if (u.origin !== window.location.origin) return;
    e.preventDefault();
    swap(clean(a.href), true);
  });

  /* ---------- Shoe chips: one Style group + one Height group, each single-choice ---------- */
  var STYLES = ['Chelsea boots', 'Lace boots', 'Dress shoes', 'Sneakers'];
  var HEIGHTS = [['2-inch-elevator-shoes', '2.0″–2.4″ Natural'], ['3-inch-elevator-shoes', '2.4″–3.0″ Maximum']];
  var data = {};
  function handleize(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function isShoePage() {
    var n = document.querySelector('.cg__chips');
    return !!n && (n.hasAttribute('data-cgx') || !!n.querySelector('.cg-chip[href*="-inch-elevator-shoes"]'));
  }
  function load(scope) {
    if (data[scope]) return data[scope];
    data[scope] = fetch('/collections/' + scope + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (j) { data[scope] = j.products.map(function (p) { return p.tags; }); return data[scope]; })
      .catch(function () { data[scope] = null; return null; });
    return data[scope];
  }
  function has(scope, tag) {
    var d = data[scope];
    if (!d || typeof d.then === 'function') return true;
    if (!tag) return d.length > 0;
    return d.some(function (t) { return t.indexOf(tag) > -1; });
  }
  function state() {
    var m = window.location.pathname.match(/\/collections\/([^\/]+)(?:\/([^\/]+))?/) || [];
    var h = null, tag = null;
    HEIGHTS.forEach(function (x) { if (x[0] === m[1]) h = x[0]; });
    if (m[2]) STYLES.forEach(function (s) { if (handleize(s) === m[2]) tag = s; });
    return { h: h, tag: tag };
  }
  function url(h, tag) {
    return (h ? '/collections/' + h : '/collections/all') + (tag ? '/' + handleize(tag) : '');
  }
  function chip(label, href, active, enabled) {
    if (!enabled && !active) return '<span class="cg-chip is-disabled" aria-disabled="true">' + label + '</span>';
    return '<a class="cg-chip' + (active ? ' is-active' : '') + '" href="' + href + '#collection-grid"' + (active ? ' aria-current="page"' : '') + '>' + label + '</a>';
  }
  function renderChips() {
    var nav = document.querySelector('.cg__chips');
    if (!nav || !isShoePage()) return;
    var st = state(), html = '';
    html += chip('All shoes', url(null, null), !st.h && !st.tag, true);
    STYLES.forEach(function (s) {
      var on = st.tag === s;
      html += chip(s, url(st.h, on ? null : s), on, has(st.h || 'all', s));
    });
    html += '<span class="cg-sep" aria-hidden="true"></span>';
    HEIGHTS.forEach(function (x) {
      var on = st.h === x[0];
      html += chip(x[1], url(on ? null : x[0], st.tag), on, has(x[0], st.tag));
    });
    nav.setAttribute('data-cgx', '1');
    nav.innerHTML = html;
  }
  if (!document.getElementById('cgx-style')) {
    var css = document.createElement('style');
    css.id = 'cgx-style';
    css.textContent = '.cg-chip.is-disabled{opacity:.35;cursor:not-allowed;pointer-events:none}.cg-sep{width:1px;align-self:stretch;min-height:20px;background:currentColor;opacity:.2;margin:4px 6px;flex:none}';
    document.head.appendChild(css);
  }
  function refresh() {
    if (!isShoePage()) return;
    renderChips();
    Promise.all(['all'].concat(HEIGHTS.map(function (x) { return x[0]; })).map(load)).then(renderChips);
  }
  refresh();
  document.addEventListener('sixft:grid-updated', refresh);

  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('[data-cg-sort]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    url.hash = '';
    swap(url.toString(), true);
  });

  window.addEventListener('popstate', function () {
    if (document.querySelector('.cg-chip')) swap(clean(window.location.href), false);
  });
})();